export default (() => {
  $('.js-card-course-list').each(function() {
    var $showMoreButton = $(this).parent().find('.js-card-course-list-show-more');
    var $hiddenList = $(this).find('.js-card-course-list-hidden');
    $showMoreButton.one("click", showMore);
    function showMore() {
      $hiddenList.slideDown(300);
      $showMoreButton.text('Show less');
      $showMoreButton.one("click", showLess);
    }
    function showLess() {
      $hiddenList.slideUp(300);
      $showMoreButton.text('Show more');
      $showMoreButton.one("click", showMore);
    }
  });
})();
